import { createContext, useContext } from 'react';

/** True when the current user is acting as a read-only viewer (came
 *  in via a token link). All editable controls (inputs, drag handles,
 *  add/remove buttons, picker dialogs) should consult this and either
 *  disable themselves or render a static span instead. */
export const ViewerContext = createContext<boolean>(false);

export const useIsViewer = (): boolean => useContext(ViewerContext);
